module.exports = __webpack_public_path__ + "img/photo-5-1.01a11283.jpg";